import { render, staticRenderFns } from "./AmendedMemArts.vue?vue&type=template&id=77d39e87&scoped=true&"
import script from "./AmendedMemArts.vue?vue&type=script&lang=js&"
export * from "./AmendedMemArts.vue?vue&type=script&lang=js&"
import style0 from "./AmendedMemArts.vue?vue&type=style&index=0&id=77d39e87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d39e87",
  null
  
)

export default component.exports